import * as converter from './units-converter';

export const MesureUnitTypeEnum = {
    MASS: "MASS",
    LENGTH: "LENGTH",
    AREA: "AREA",
    VOLUME: "VOLUME",
    LINEAR: "LINEAR"
};

export const MeasureUnits = [
    { value: "MILLIGRAM", label: "Milligram", unit: "mg", type: MesureUnitTypeEnum.MASS, strength: 1 },
    { value: "GRAM", label: "Gram", unit: "g", type: MesureUnitTypeEnum.MASS, strength: 2 },
    { value: "KILOGRAM", label: "Kilogram", unit: "kg", type: MesureUnitTypeEnum.MASS, strength: 4 },
    { value: "OUNCE", label: "Ounce", unit: "oz", type: MesureUnitTypeEnum.MASS, strength: 3 },
    { value: "MILLILITER", label: "Milliliter", unit: "ml", type: MesureUnitTypeEnum.AREA, strength: 1 },
    { value: "LITRE", label: "Litre", unit: "l", type: MesureUnitTypeEnum.VOLUME, strength: 2 },
    { value: "PIECE", label: "Piece", unit: "pcs", type: MesureUnitTypeEnum.LINEAR, strength: 1 },
    { value: "PERCENT", label: "Percent", unit: "%", type: MesureUnitTypeEnum.LINEAR, strength: 1 },
    { value: "MILLIMETER", label: "Millimeter", unit: "mm", type: MesureUnitTypeEnum.LENGTH, strength: 1 },
    { value: "CENTIMETER", label: "Centimeter", unit: "cm", type: MesureUnitTypeEnum.LENGTH, strength: 2 },
    { value: "METER", label: "Meter", unit: "m", type: MesureUnitTypeEnum.LENGTH, strength: 3 },
    { value: "AREA", label: "Meter SQ.;", unit: "m2", type: MesureUnitTypeEnum.AREA, strength: 1 },
    { value: "VOLUME", label: "Meter QB.", unit: "m3", type: MesureUnitTypeEnum.VOLUME, strength: 2 },
];

export function ConvertMesureUnit(value, from, to) {
    try {
        if (from.type !== to.type) {
            return { success: false, value };
        }
        const alg = converter[from.type.toLowerCase()];
        if (alg) {
            const convertedValue = alg(value).from(from.unit).to(to.unit);
            return { ...convertedValue, success: true };
        }
    } catch (e) {
        return { success: false, value };
    }
}

export function getSelectedMeasureUnit(value, withObj = false) {
    const mu = MeasureUnits.find(a => a.value === value);
    if (mu == null) return withObj ? null : "";

    return withObj ? mu : `${mu.label} (${mu.unit.toUpperCase()})`;
}

export const ProcessStatus = {
    "QUEUED": {
        label: "Queued",
        changables: ["APPROVED", "CANCELLED"]
    },
    "APPROVED": {
        label: "Approved",
        changables: ["QUEUED", "IN_PROGRESS", "CANCELLED"]
    },
    "IN_PROGRESS": {
        label: "In Progress",
        changables: ["PARTIAL_COMPLETED", "CANCELLED"]
    },
    "PARTIAL_COMPLETED": {
        label: "Partial Completed",
        changables: ["IN_PROGRESS","COMPLETED", "CANCELLED"]
    },
    "COMPLETED": {
        label: "Completed",
        changables: []
    },
    "CANCELLED": {
        label: "Canceled",
        changables: []
    }
};

// export const PurchaseStatus = {
//     "ORDERED": {
//         label: "Ordered",
//         changables: ["RECEIVED", "CLOSED"]
//     },
//     "RECEIVED": {
//         label: "Received",
//         changables: ["CLOSED"]
//     },
//     "CLOSED": {
//         label: "Closed",
//         changables: []
//     }
// };


export const StatusTypeEnum = {
    Ordered: "ORDERED",
    Received: "RECEIVED",
    Closed: "CLOSED"
};
export const CostTypeEnum = {
    LabourCost: "CP_LABOR",
    TransportCost: "CP_TRANSPORT",
    Tax: "CP_TAX",
    Others: "CP_OTHERS",
    Rent: "CP_RENT",
    UtilityCost: "CP_UTILITY",
};


export const SalaryItemTypeEnum = {
    Basic: "BASIC",
    Allowance: "ALLOWANCE",
    Bonus: "BONUS",
    Appreciation: "APPRECIATION",
    Deduction: "DEDUCTION",
    Insurance: "INSURANCE",
    Standalone:"STANDALONE",
    StandaloneInput:"STANDALONE_INPUT",
};


export const XRepeat = {
    OneTime: "ONE_TIME",
    Daily: "DAILY",
    Weekly: "WEEKLY",
    Monthly: "MONTHLY",
    Yearly: "YEARLY",
    Custom: "CUSTOM",
    WorkingHour:"WORKING_HOUR",
    WorkingDay:"WORKING_DAY",
} 
 
export const EmployeeType = {
    Hourly: "HOURLY",
    PartTime: "PART_TIME",
    FullTime: "FULL_TIME",
    Contractual: "CONTRACTUAL"
}

export const DepartmentType = {
    General: "GENERAL",
    Store: "STORE",
    Production: "PRODUCTION"
}


export const UserDocType = {
    Certificate: "CERTIFICATE",
    NID: "NID",
    BirthCertificate: "BIRTH_CERTIFICATE",
    Resume: "RESUME",
    Photo: "PHOTO",
    AppointmentLetter: "APPOINTMENT_LETTER",
    ResignLetter: "RESIGN_LETTER"
}

export const AmountType = {
    Value: "VALUE",
    Percent: "PERCENTAGE",
    Multiplexer: "MULTIPLEXER"
}

export const LeaveAccumulationMethod = {
    Monthly: "MONTHLY",
    Quarterly: "QUARTERLY",
    Half_Yearly: "HALF_YEARLY",
    Yearly: "YEARLY"
}

export const LeaveRequestStatus = {
    Pending: "PENDING",
    Approved: "APPROVED",
    Rejected: "REJECTED",
    Cancelled: "CANCELLED"
}

export const ProductionFormulaType = {
    RawMaterials: "RAW_MATERIALS",
    FinishedGoods: "FINISHED_GOODS",
    Herb: "HERB",
    Packaging: "PACKAGING",
    Others: "OTHERS"
}




// WEBPACK FOOTER //
// ./src/common/Enumarations.js